import { SITE_ROUTES } from "@/config/siteRoutes";
import { getSiteLocale, localizeHref, stripLocalePrefix } from "@/i18n/locale";

const HOME_SCROLL_STORAGE_KEY = "venuex-horizontal-scroll:/";
const HOME_RESET_FLAG_KEY = "venuex-home-reset-to-hero";
export const HOME_HERO_RESET_EVENT = "venuex:reset-home-hero";

export const HOME_HERO_URL = localizeHref(SITE_ROUTES.home, getSiteLocale());

export function prepareHomeHeroNavigation() {
  try {
    window.sessionStorage.removeItem(HOME_SCROLL_STORAGE_KEY);
    window.sessionStorage.setItem(HOME_RESET_FLAG_KEY, "true");
  } catch {
    // Ignore storage failures and still allow the navigation to continue.
  }
}

export function consumeHomeHeroResetRequest() {
  try {
    const hasStoredReset = window.sessionStorage.getItem(HOME_RESET_FLAG_KEY) === "true";

    if (hasStoredReset) {
      window.sessionStorage.removeItem(HOME_RESET_FLAG_KEY);
    }

    return hasStoredReset;
  } catch {
    return false;
  }
}

type ClickEventLike = {
  preventDefault: () => void;
};

function isHomePath(pathname: string) {
  const normalized = stripLocalePrefix(pathname);
  return normalized === SITE_ROUTES.home || normalized === "";
}

export function handleHomeHeroClick(event?: ClickEventLike) {
  prepareHomeHeroNavigation();

  if (!isHomePath(window.location.pathname)) {
    return;
  }

  event?.preventDefault();
  window.dispatchEvent(new Event(HOME_HERO_RESET_EVENT));
}
